import { Component, computed, inject, input, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { SystemMakersIds } from '@devices/models';
import { Firmware } from '@devices/models/firmware';
import { compare } from 'compare-versions';
import { filter } from 'rxjs';

import { UpdateFirmwareDialogComponent } from '../update-firmware-dialog';

@Component({
  imports: [MatTooltip],
  selector: 'avs-firmware-status',
  styleUrl: './firmware-status.component.scss',
  templateUrl: './firmware-status.component.html',
})
export class FirmwareStatusComponent {
  config = input.required<{
    deviceId: string;
    firmware: Partial<Firmware> | null,
    manufacturerId: string;
    version: string;
  }>();

  protected tooltip = computed(() => {
    if (this.isUpdating()) {
      return 'Update in progress';
    }

    return 'Update available';
  });

  protected hasUpdate = computed(() => {
    const { firmware, version } = this.config();

    if (!firmware?.version || !version) {
      return false;
    }

    try {
      return compare(firmware.version, version, '>');
    } catch {
      return false;
    }
  });

  protected showButton = computed(() => {
    return this.config().manufacturerId === SystemMakersIds.AVServices && this.hasUpdate();
  });

  protected isUpdating = signal(false);
  private dialog = inject(MatDialog);

  protected openUpdateFirmwareDialog() {
    this.dialog.open(UpdateFirmwareDialogComponent, {
      data: {
        currentVersion: this.config().version,
        deviceId: this.config().deviceId,
        firmware: this.config().firmware,
      },
    }).afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => {
        this.isUpdating.set(true);
      });
  }
}
